!(function () {
  "use strict";
  var e = {
      4559: function (e, t, r) {
        r.d(t, {
          Dz: function () {
            return n;
          },
          aO: function () {
            return o;
          },
          sg: function () {
            return c;
          },
        });
        const n = function () {
            return {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: `application/${
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : "json"
                }`,
              },
            };
          },
          o = async function () {
            let e, t;
            try {
              e = await fetch(...arguments);
              if (!e.ok) throw new Error(`Fetch failed: ${e.status}`);
            } catch (e) {
              t = e;
            }
            return { response: e, error: t };
          };
        function c(e, t) {
          const r = this;
          let n;
          return function () {
            for (var o = arguments.length, c = new Array(o), a = 0; a < o; a++)
              c[a] = arguments[a];
            clearTimeout(n),
              (n = setTimeout(function () {
                return e.apply(r, c);
              }, t));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
            const t = e.target.getAttribute("href");
            ((e) => {
              Math.easeInOutQuad = function (e, t, r, n) {
                return (e /= n / 2) < 1
                  ? (r / 2) * e * e + t
                  : (-r / 2) * (--e * (e - 2) - 1) + t;
              };
              const t = document.getElementById("grid-archive-header"),
                r = document.getElementById("nav-wrapper");
              let n = 0,
                o = 0;
              t && (n = t.offsetHeight + 50), r && (o = r.offsetHeight + 50);
              const c = e.offsetTop - n - o,
                a = window.scrollY,
                i = c - a;
              let s = 0;
              const l = () => {
                s += 5;
                const e = Math.easeInOutQuad(s, a, i, 200);
                window.scrollTo(0, e), s < 200 && setTimeout(l, 5);
              };
              l();
            })(document.querySelector(t));
          });
        });
      },
    },
    t = {};
  function r(n) {
    var o = t[n];
    if (void 0 !== o) return o.exports;
    var c = (t[n] = { exports: {} });
    return e[n](c, c.exports, r), c.exports;
  }
  (r.d = function (e, t) {
    for (var n in t)
      r.o(t, n) &&
        !r.o(e, n) &&
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
  }),
    (r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      var e = r(4559);
      class t extends HTMLElement {
        constructor() {
          super(),
            (this.items = Array.from(this.querySelectorAll(".cart-item"))),
            this.items.forEach((e) => this.manageState(e)),
            (this.selectorsToUpdate = [
              ".cart-summary__header",
              "#cart-total-price",
              "#checkout",
              ".cart-summary__free-shipping",
            ]),
            (this.mainCartSelector = ".shopify-section.cart"),
            (this.miniCartSelector = "#mini-cart"),
            (this.itemsContainersSelector =
              ".cart-items-container, .mini-cart--empty"),
            (this.parser = new DOMParser());
        }
        manageState(e) {
          const t = e.getAttribute("data-item-id"); // Changed to data-item-id
          e.querySelector(
            ".cart-item-delete, .cart-item__remove"
          ).addEventListener("click", async () => {
            // await this.changeCartItem({ id: t, quantity: 0 });
            

await this.changeCartItem({ line: t, quantity: 0 });


          });
          const r = e.querySelector('input[name="quantity"]');
          if (!r) return;
          const n = e.querySelector('button[name="plus"]'),
            o = e.querySelector('button[name="minus"]');
          let c = parseInt(r.value);
          n.addEventListener("click", () => {
            c = parseInt(r.value) + 1; // Ensure fresh value
            r.value = c;
            this.changeCartItem({ id: t, quantity: c });
          });
          o.addEventListener("click", () => {
            c = parseInt(r.value) - 1; // Ensure fresh value
            if (c >= 0) {
              r.value = c;
              this.changeCartItem({ id: t, quantity: c });
            }
          });
          // Handle direct input changes
          r.addEventListener("change", () => {
            c = parseInt(r.value);
            if (!isNaN(c) && c >= 0) {
              this.changeCartItem({ id: t, quantity: c });
            } else {
              r.value = c; // Revert invalid input
            }
          });
        }
      async changeCartItem(t) {
  console.log('changeCartItem:', t); // Debug
  const { response: r, error: n } = await (0, e.aO)(
    `${routes.cartChange}`,
    {
      ...(0, e.Dz)(),
      body: JSON.stringify({
        // id: t.id,
        line: t.line,
        quantity: t.quantity,
        sections: "cart,mini-cart", // Ensure correct section names
      }),
    }
  );
  if (n || !r.ok) {
    console.error('Cart change error:', n || `HTTP ${r.status}`);
    const errorEl = document.querySelector('#cart-errors');
    if (errorEl) errorEl.textContent = 'Error updating cart. Please try again.';
    return;
  }
  const o = await r.json();
  console.log('Cart change response:', o); // Debug: Check total_price, item_count, sections

  if (o.errors) {
    console.error('Cart errors:', o.errors);
    const errorEl = document.querySelector('#cart-errors');
    if (errorEl) errorEl.textContent = `Error: ${o.errors}`;
    return;
  }

  // Immediate fallback update for subtotal and count
  document.querySelectorAll('#cart-total-price').forEach(el => {
    if (typeof Shopify?.formatMoney === 'function' && Shopify?.money_format) {
      el.textContent = Shopify.formatMoney(o.total_price, Shopify.money_format);
    } else {
      el.textContent = `$${(o.total_price / 100).toFixed(2)}`; // Fallback
    }
  });
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = o.item_count;
    el.classList.toggle('visually-hidden', o.item_count === 0);
  });

  const c = o.sections?.["cart"]
    ? this.parser.parseFromString(o.sections["cart"], "text/html")
    : null;
  const a = o.sections?.["mini-cart"]
    ? this.parser.parseFromString(o.sections["mini-cart"], "text/html")
    : null;

  if (o.item_count === 0) {
    if (c && document.querySelector(this.mainCartSelector)) {
      document.querySelector(this.mainCartSelector).innerHTML =
        c.querySelector(this.mainCartSelector).innerHTML;
    }
    if (a && document.querySelector(this.miniCartSelector)) {
      document.querySelector(this.miniCartSelector).innerHTML =
        a.querySelector(this.miniCartSelector).innerHTML;
    }
    const t = document.querySelector("drawer-component");
    t && (t.connect(), t.attachOverlay());
    document
      .querySelectorAll("#mini-cart .icon")
      .forEach((e) => e.classList.add("loaded"));
    c && this.renderElements(c);
  } else {
    if (c) {
      // Force update the .cart-items-container with debug logging
      const itemsContainer = document.querySelector(this.itemsContainersSelector);
      if (itemsContainer) {
        const newContainer = c.querySelector(this.itemsContainersSelector);
        if (newContainer) {
          console.log('New cart-items-container HTML:', newContainer.innerHTML); // Debug
          itemsContainer.innerHTML = newContainer.innerHTML;
          // Rebind manageState for new items
          document.querySelectorAll(".cart-item").forEach((e) => {
            this.manageState(e);
          });
        } else {
          console.warn('New cart-items-container not found in response');
        }
      }
      // Update the entire cart section as fallback
      const cartSection = document.querySelector(this.mainCartSelector);
      if (cartSection) {
        cartSection.innerHTML = c.querySelector(this.mainCartSelector).innerHTML;
      }
    }
    if (a && document.querySelector(this.miniCartSelector)) {
      document.querySelector(this.miniCartSelector).innerHTML =
        a.querySelector(this.miniCartSelector).innerHTML;
    }
  }

  // Re-init third-party scripts
  setTimeout(() => {
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.extensions) {
      Object.values(window.Shopify.theme.extensions).forEach(ext => {
        if (ext.init) ext.init();
      });
    }
  }, 100);
}
        renderElements(e) {
          this.selectorsToUpdate.forEach((t) => {
            try {
              const r = document.querySelectorAll(t),
                n = e.querySelector(t);
              r.length &&
                n &&
                r.forEach((e) => {
                  n
                    .querySelectorAll(".icon")
                    .forEach((e) => e.classList.add("loaded")),
                    e.replaceWith(n.cloneNode(!0));
                });
            } catch (e) {
              console.error(`Error updating ${t}`, e);
            }
          });
          const t = e.querySelector(".cart-count");
          document
            .querySelectorAll(
              "#cart-open-block .header__icons--cart-open .cart-count"
            )
            .forEach((e) => {
              t
                ? (e.classList.contains("visually-hidden") &&
                    e.classList.remove("visually-hidden"),
                  (e.textContent = t.textContent))
                : e.classList.add("visually-hidden");
            });
          document
            .querySelector("#cart-open-block .icon")
            ?.classList.add("loaded");
        }
        renderItems(e) {
          this.renderElements(e);
          const t = Array.from(
              document.querySelectorAll(this.itemsContainersSelector)
            ),
            r = e.querySelector(this.itemsContainersSelector);
          t.forEach((e) => {
            e && r && e.replaceWith(r.cloneNode(!0));
          });
          document.querySelectorAll(".cart-item").forEach((e) => {
            e
              .querySelectorAll(".icon")
              .forEach((e) => e.classList.add("loaded"));
            this.manageState(e); // Rebind events
          });
        }
      }
      customElements.get("cart-service") ||
        customElements.define("cart-service", t),
        customElements.get("cart-note") ||
          customElements.define(
            "cart-note",
            class extends HTMLElement {
              constructor() {
                super(),
                  this.querySelector("textarea").addEventListener(
                    "change",
                    (0, e.sg)((t) => {
                      const r = JSON.stringify({ note: t.target.value });
                      fetch(`${routes.cartUpdate}`, {
                        ...(0, e.Dz)(),
                        body: r,
                      });
                    }, 300)
                  );
              }
            }
          );
    })();
})();